<template>
    <v-container fluid>
        <v-row justify="center"
               class="mb-4"
               no-gutters>
            <v-col cols="11">
                <v-form ref="queryForm">
                    <v-row justify="center">
                        <v-col cols="2" class="pb-0 pr-0">
                            <z-source-selector label="领用部门"
                                               :hideDetails="'auto'"
                                               source="DeptSelector"
                                               v-model="queryRequest.receiverDeptId">
                            </z-source-selector>
                        </v-col>
                        <v-col
                                cols="2" class="pb-0 pr-0">
                            <z-source-selector label="管理方部门"
                                               :hideDetails="'auto'"
                                               source="DeptSelector"
                                               v-model="queryRequest.assetsManageDeptId">
                            </z-source-selector>
                        </v-col>
                        <v-col cols="2" class="pb-0 pr-0">
                            <v-text-field
                                    label="借用单号"
                                    hide-details="auto"
                                    prepend-inner-icon="search"
                                    clearable
                                    v-model="queryRequest.borrowCode"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="2" class="pb-0 pr-0">
                            <v-text-field
                                    label="设备编号"
                                    hide-details="auto"
                                    prepend-inner-icon="search"
                                    clearable
                                    v-model="queryRequest.assetsCode"
                            ></v-text-field>
                        </v-col>
                        <v-col
                                cols="4" class="pb-0 pr-0">
                            <v-badge
                                    :content="querySelected"
                                    :value="querySelected!=0"
                                    color="green"
                                    overlap
                            >
                                <v-btn :loading="isSearchLoading"
                                       color="primary"
                                       @click="query">
                                    搜索
                                </v-btn>
                            </v-badge>

                            <v-btn color="primary"
                                   class="ma-2"
                                   @click="resetQuery">
                                <v-icon>mdi-refresh</v-icon>
                            </v-btn>

                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                            v-on="on"
                                            class="mx-2"
                                            icon
                                            color="primary"
                                            @click="extend">
                                        <v-icon v-if="!seniorQueryFlag" large>mdi-arrow-down-drop-circle</v-icon>
                                        <v-icon v-else large>mdi-arrow-up-drop-circle</v-icon>
                                    </v-btn>
                                </template>
                                <span>高级搜索按钮</span>
                            </v-tooltip>

                            <v-btn color="primary"
                                   class="ma-2"
                                   @click="report">一键导出
                            </v-btn>

                        </v-col>
                    </v-row>
                    <v-expand-transition>
                        <div v-show="seniorQueryFlag">
                            <v-row>
                                <v-col cols="2" class="pb-0 pr-0">
                                    <v-text-field
                                            hide-details="auto"
                                            label="设备名称"
                                            prepend-inner-icon="search"
                                            clearable
                                            v-model="queryRequest.assetsName"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="2" class="pb-0 pr-0">
                                    <v-text-field
                                            hide-details="auto"
                                            label="品牌"
                                            prepend-inner-icon="search"
                                            clearable
                                            v-model="queryRequest.assetsBrand"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="2" class="pb-0 pr-0">
                                    <v-text-field
                                            hide-details="auto"
                                            label="型号"
                                            prepend-inner-icon="search"
                                            clearable
                                            v-model="queryRequest.assetsModel"
                                    ></v-text-field>
                                </v-col>
                                <v-col
                                        cols="2" class="pb-0 pr-0">
                                    <v-text-field
                                            label="管理负责人"
                                            hide-details="auto"
                                            prepend-inner-icon="search"
                                            clearable
                                            v-model="queryRequest.assetsManager"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="2" class="pb-0 pr-0">
                                    <v-text-field
                                            label="领用人"
                                            hide-details="auto"
                                            prepend-inner-icon="search"
                                            clearable
                                            v-model="queryRequest.receiverPerson"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="2" class="pb-0 pr-0">
                                    <v-text-field
                                            label="借用审批人"
                                            hide-details="auto"
                                            prepend-inner-icon="search"
                                            clearable
                                            v-model="queryRequest.borrowApprover"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <!-- 第二行 -->
                            <v-row justify="center">
                                <v-col cols="2" class="pb-0 pr-0">
                                    <v-text-field
                                            label="归还人"
                                            hide-details="auto"
                                            prepend-inner-icon="search"
                                            clearable
                                            v-model="queryRequest.returnPerson"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="2" class="pb-0 pr-0">
                                    <v-text-field
                                            label="归还验收人"
                                            hide-details="auto"
                                            prepend-inner-icon="search"
                                            clearable
                                            v-model="queryRequest.accepterPerson"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="2" class="pb-0 pr-0">
                                    <z-source-selector label="归还状态"
                                                       :hide-details="'auto'"
                                                       :param="'BORROW_RECORD_STATE'"
                                                       v-model="queryRequest.state">
                                    </z-source-selector>
                                </v-col>
                                <v-col cols="2" class="pb-0 pr-0">
                                    <v-text-field
                                            label="费用（棕叶）"
                                            hide-details="auto"
                                            prepend-inner-icon="search"
                                            clearable
                                            v-model="queryRequest.cost"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="2" class="pb-0 pr-0">
                                    <v-text-field
                                            label="使用时长（天）"
                                            hide-details="auto"
                                            prepend-inner-icon="search"
                                            clearable
                                            v-model="queryRequest.useDays"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="2" class="pb-0 pr-0">
                                    <v-text-field
                                            label="逾期时长（天）"
                                            hide-details="auto"
                                            prepend-inner-icon="search"
                                            clearable
                                            v-model="queryRequest.overdueDays"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <!-- 第三行，开始选择日期 -->
                            <v-row>
                                <v-col cols="4" class="pb-0 pr-0">
                                    <z-select-date label="领用"
                                                   :startDateRules="[]"
                                                   :endDateRules="[]"
                                                   :hide-details="'auto'"
                                                   v-model="queryRequest.receiverTime">
                                    </z-select-date>
                                </v-col>
                                <v-col cols="4" class="pb-0 pr-0">
                                    <z-select-date label="归还"
                                                   :startDateRules="[]"
                                                   :endDateRules="[]"
                                                   :hide-details="'auto'"
                                                   v-model="queryRequest.shouldReturnTime">
                                    </z-select-date>
                                </v-col>
                                <v-col cols="4" class="pb-0 pr-0">
                                    <z-select-date label="实际归还"
                                                   :hide-details="'auto'"
                                                   :startDateRules="[]"
                                                   :endDateRules="[]"
                                                   v-model="queryRequest.returnRealTime">
                                    </z-select-date>
                                </v-col>
                                <v-col cols="4" class="pb-0 pr-0">
                                    <z-select-date label="归还验收"
                                                   :hide-details="'auto'"
                                                   :startDateRules="[]"
                                                   :endDateRules="[]"
                                                   v-model="queryRequest.accepterTime">
                                    </z-select-date>
                                </v-col>
                            </v-row>
                            <!-- 前3行输入框结束 -->
                        </div>
                    </v-expand-transition>

                </v-form>
            </v-col>
        </v-row>

        <v-row class="d-flex justify-center">
            <v-col cols="11">
                <v-data-table
                        :headers="headers"
                        :items="list"
                        disable-sort
                        single-expand
                        show-expand
                        :options.sync="options"
                        :page.sync="queryRequest.pagedQueryInfo.index"
                        :server-items-length="total">
                    <template v-slot:expanded-item="{ headers, item }">
                        <td :colspan="headers.length">
                            <div style="padding:10px 0;">
                              <span>预计使用天数</span>：
                              <span>{{item.useDays}}</span>
                            </div>
                            <div style="padding:10px 0;">
                                <span>借用单号</span>：
                                <span>{{item.borrowCode}}</span>
                            </div>
                            <div style="padding:10px 0;">
                                <span>设备编号</span>：
                                <span>{{item.assetsCode}}</span>
                            </div>
                            <div style="padding:10px 0;">
                                <span>管理部门</span>：
                                <span>{{item.assetsManageDept}}</span>
                            </div>
                            <div style="padding:10px 0;">
                                <span>领用时间</span>：
                                <span>{{item.receiverTime}}</span>
                            </div>
                            <div style="padding:10px 0;">
                                <span>领用图片</span>：
                                <v-row>
                                    <v-col cols="4"
                                           v-for="(itemImg,index) in item.receiverImgList"
                                           :key="index">
                                        <v-img :src="itemImg"
                                               aspect-ratio="1.7"
                                               contain></v-img>
                                    </v-col>
                                </v-row>
                            </div>
                            <div style="padding:10px 0;">
                                <span>领用说明</span>：
                                <span>{{item.receiverRemarks}}</span>
                            </div>
                            <div style="padding:10px 0;">
                                <span>领用人签名</span>：
                                    <v-img v-if="item.receiverPersonSign!=null" style="transform: rotate(-90deg);margin-left: 30px;margin-top:40px;margin-bottom: 40px;height: 150px"
                                            width="100" :src="item.receiverPersonSign"></v-img>
                            </div>
                            <div style="padding:10px 0;">
                              <span>借用审批人签名</span>：
                                <v-img v-if="item.borrowApproverSign!=null" style="transform: rotate(-90deg);margin-left: 30px;margin-top:40px;margin-bottom: 40px;height: 150px"
                                       width="100" :src="item.borrowApproverSign"></v-img>
                            </div>
                            <div style="padding:10px 0;">
                                <span>应归还时间</span>：
                                <span>{{item.shouldReturnTime}}</span>
                            </div>
                            <div style="padding:10px 0;">
                                <span>归还时间</span>：
                                <span>{{item.returnRealTime}}</span>
                            </div>
                            <div style="padding:10px 0;">
                                <span>归还图片</span>：
                                <v-row>
                                    <v-col cols="4"
                                           v-for="(itemImg,index) in item.returnImgList"
                                           :key="index">
                                        <v-img :src="itemImg"
                                               aspect-ratio="1.7"
                                               contain></v-img>
                                    </v-col>
                                </v-row>
                            </div>
                            <div style="padding:10px 0;">
                                <span>归还说明</span>：
                                <span>{{item.returnRemarks}}</span>
                            </div>
                            <div style="padding:10px 0;">
                                <span>归还验收时间</span>：
                                <span>{{item.accepterTime}}</span>
                            </div>
                            <div style="padding:10px 0;">
                              <span>归还验收人签名</span>：
                                <v-img v-if="item.accpeterPersonSign!=null" style="transform: rotate(-90deg);margin-left: 30px;margin-top:40px;margin-bottom: 40px;height: 150px"
                                       width="100" :src="item.accpeterPersonSign"></v-img>
                            </div>
                            <div style="padding:10px 0;">
                              <span>负责人</span>：
                              <span>{{item.assetsManager}}</span>
                            </div>
                        </td>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <z-loading v-model="isLoading"></z-loading>

    </v-container>
</template>

<script>
  import {mdiArrowDownDropCircle} from '@mdi/js';
  import {
    query,
    reportExport
  } from '@/api/recordQuery'
  import {dataChangedCountMixin} from "@/mixin"
  import downloadReportExcel from "@/utils/reportDownLoad"

  export default {
    name: "RecordQuery",
    data() {
      return {
        isLoading: false,
        isSearchLoading: false,
        seniorQueryFlag: false,
        queryRequest: {
          accepterTime: [],
          assetsManageDept: '',
          assetsManageDeptId:'',
          assetsManager: '',
          pagedQueryInfo: {
            index: 1,
            pageSize: 10
          },
          borrowCode: "",
          assetsCode: "",
          assetsBrand: "",
          assetsModel: "",
          assetsName: "",
          receiverPerson: "",
          receiverPersonId: "",
          receiverPersonPhone: "",
          receiver: "",
          receiverId: "",
          receiverDept: "",
          receiverDeptId: "",
          receiverTime: [],
          shouldReturnTime: [],
          borrowApprover: "",
          borrowApproverId: "",
          returnPerson: "",
          returnPersonId: "",
          returnPersonPhone: "",
          returnRealTime: [],
          cost: 0,
          useDays: "",
          overdueDays: "",
          accepterPerson: "",
          accepterPersonId: "",
          state: ""
        },
        options: {},
        total: 1,
        list: [],
        headers: [
          // {text: '借用单号', value: 'borrowCode',},
          {text: '设备编号', value: 'assetsCode',},
          {text: '设备名称', value: 'assetsName'},
          {text: '品牌', value: 'assetsBrand'},
          {text: '型号', value: 'assetsModel'},
          {text: '借用日期', value: 'receiverTime'},
          // {text: '负责人', value: 'assetsManager',},
          {text: '领用部门', value: 'receiverDept',},
          {text: '领用人', value: 'receiverPerson'},
          {text: '借用审批人', value: 'borrowApprover'},
          {text: '归还人', value: 'returnPerson'},
          {text: '归还验收人', value: 'accepterPerson'},
          // {text: '管理部门', value: 'assetsManageDept', sortable: false},
          // {text: '预计使用天数', value: 'useDays'},
          {text: '借用天数', value: 'realUseDays'},
          {text: '逾期天数', value: 'overdueDays'},
          {text: '使用时长', value: 'realBorrowedTime'},
          {text: '费用(棕叶)', value: 'cost'},
          {text: '归还状态', value: 'stateDesc'},
          {text: '详情', value: 'data-table-expand'},
        ],
      }
    },
    mixins: [dataChangedCountMixin],
    watch: {
      options: {
        handler(val) {
          if (val.itemsPerPage == -1) {
            this.queryRequest.pagedQueryInfo.index = 1
            this.queryRequest.pagedQueryInfo.pageSize = 999999
          } else if (!!val.page && !!val.itemsPerPage) {
            this.queryRequest.pagedQueryInfo.index = val.page
            this.queryRequest.pagedQueryInfo.pageSize = val.itemsPerPage
          }
          // this.queryRequest.sortInfo.sortBy = val.sortBy
          // this.queryRequest.sortInfo.sortDesc = val.sortDesc
          this.handleQuery()
        }
      }
    },
    methods: {
      query(){
        this.queryRequest.pagedQueryInfo.index = 1;
        this.handleQuery();
      },
      handleQuery() {
        this.isSearchLoading = true;
        console.log(this.queryRequest, 'this.queryRequest');
        query(this.queryRequest).then(res => {
          this.isSearchLoading = false;
          this.list = res.list;
          this.total = res.total;
        }).catch(err => {
          this.isSearchLoading = false;
        });
      },
      resetQuery() {
        // console.log(this.$options.data(),'99999999999999');
        // console.log(this.$data,'888888888888');
        Object.assign(this.$data, this.$options.data())
      },
      report() {
        this.isLoading = true;
        reportExport(this.queryRequest).then(res => {
          downloadReportExcel(res);
          this.isLoading = false;
        }).catch(err => {
          this.isLoading = false;
        });
      },
      extend() {
        this.seniorQueryFlag = !this.seniorQueryFlag;
      }
    },
    created() {
      if (this.$route.query.assetsName) {
        this.queryRequest.assetsName = this.$route.query.assetsName;
      }
      if (this.$route.query.assetsCode) {
        this.queryRequest.assetsCode = this.$route.query.assetsCode;
      }
    }
  }
</script>

<style lang="sass" scoped type="text/css">



</style>